import './polyfill';
import 'focus-visible/dist/focus-visible.min';
import store from 'store';
import smoothAnchors from './smooth-anchors';

import { qs, qsAll } from './dom-helpers';

import Minicart from './classes/class.Minicart';
import GoogleMaps from './classes/class.GoogleMaps';
import Tabs from './classes/class.Tabs';
import CategoryFilter from './classes/class.CategoryFilter';
import ContactForm from './classes/class.ContactForm';
import HomeSlider from './classes/class.HomeSlider';
import AllergyFilter from './classes/class.AllergyFilter';
import FloatingLabels from './classes/class.FloatingLabels';
import Cart from './classes/class.Cart';
import SingleProduct from './classes/class.SingleProduct';
import ProductBlock from './classes/class.ProductBlock';
import Checkout from './classes/class.Checkout';
import Input from './classes/class.Input';
import Policies from './classes/class.Policies';
import ChangePassword from './classes/class.ChangePassword';
import Recipe from './classes/class.Recipe';
import LoginModal from './classes/class.LoginModal';
import RegistrationForm from './classes/class.RegistrationForm';
import ForgotPassword from './classes/class.ForgotPassword';
import ProductSearch from './classes/class.ProductSearch';

class Main {
  constructor() {
    this.mainHeader = document.querySelector('.main-header:not(.main-header--fixed)');
    this.transparentHeader = document.querySelector('.main-header--fixed');
    this.initStickyHeaderY = 20;
    this.hambButton = document.querySelector('.hamburger');
    this.mobNavList = document.querySelector('.main-header__nav-list--mobile');
    this.headerColor = document.querySelector('.main-header');
    this.contactsMap = document.querySelector('.contacts__map');
    this.mainFooter = document.getElementById('main-footer');
    this.mainContent = document.querySelector('main');
    this._run();
  }

  _run() {
    smoothAnchors();

    this._registerGlobalObjects();
    this._initStickyHeader();
    this._initHamburgerMenu();

    new FloatingLabels();
    new Minicart();
    new ProductSearch();
    new GoogleMaps(this.contactsMap, 0).initMap();
    new Tabs();
    new CategoryFilter();
    new ContactForm();
    new HomeSlider();
    new AllergyFilter('.similar-products__list', '.similar-products__item');
    new AllergyFilter('.products__list', '.product-item');
    new SingleProduct();
    new Cart();
    new Checkout();
    new ProductBlock();
    new Input().init();
    new ChangePassword();
    new Policies();
    new Recipe();
    new LoginModal();
    new RegistrationForm();
    new ForgotPassword();

    this._setPageMinHeight();
    window.addEventListener('resize', () => this._setPageMinHeight());
  }

  _setPageMinHeight() {
    let h = (window.innerHeight - document.documentElement.offsetHeight + this.mainContent.offsetHeight);
    if (h > 0) this.mainContent.style.minHeight = h + 'px'
  }

  _registerGlobalObjects() {
    window.qs = qs;
    window.qsAll = qsAll;
    window.store = store;
  }

  _initStickyHeader() {
    const header = this.transparentHeader || this.mainHeader;
    const headerClass = this.transparentHeader
      ? ['main-header--white', 'main-header--white-mob']
      : ['main-header--white-mob'];

    if (window.scrollY >= this.initStickyHeaderY) {
      header.classList.add(...headerClass);
    }

    window.addEventListener('scroll', () => {
      if (window.scrollY >= this.initStickyHeaderY) {
        header.classList.add(...headerClass);
      } else {
        header.classList.remove(...headerClass);
      }
    });
  }

  _initHamburgerMenu() {
    this.hambButton.addEventListener('click', () => {
      this.hambButton.classList.toggle('is-active');
      this.mobNavList.classList.toggle('main-header__nav-list--mobile-active');
      this.headerColor.classList.toggle('main-header--black');
      document
        .querySelector('.main-header__nav--mobile .main-header__cart-link')
        .classList
        .toggle('main-header__cart-link--white');

      document.body.style.overflow
        ? document.body.style.overflow = 'visible'
        : document.body.style.overflow = 'hidden';
    });
  }
}

document.addEventListener('DOMContentLoaded', () => new Main());
